// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';
import enUsLocale from 'date-fns/locale/en-US';

const defaultMonthValues = [
  'Janeru',
  'Fevereru',
  'Marsu',
  'Abril',
  'Maiu',
  'Junhu',
  'Julhu',
  'Agostu',
  'Sitenbru',
  'Otubru',
  'Novenbru',
  'Dizenbru',
];

const abbreviatedMonthValues = [
  'Jan.',
  'Fev.',
  'Marsu',
  'Abril',
  'Maiu',
  'Junhu',
  'Julhu',
  'Ago.',
  'Sit.',
  'Otu.',
  'Nov.',
  'Diz.',
];

const monthValues = {
  narrow: abbreviatedMonthValues,
  abbreviated: abbreviatedMonthValues,
  wide: defaultMonthValues,
};

const defaultDayValues = [
  'Dumingu',
  'Sigunda-fera',
  'Tersa-fera',
  'Kuarta-fera',
  'Kinta-fera',
  'Sesta-fera',
  'Sabadu',
];

const abbreviatedDayValues = ['Dum', 'Sig', 'Ter', 'Kua', 'Kin', 'Ses', 'Sab'];

const dayValues = {
  narrow: abbreviatedDayValues,
  short: abbreviatedDayValues,
  abbreviated: abbreviatedDayValues,
  wide: defaultDayValues,
};

const defaultDayPeriodValues = {
  am: 'di sedu',
  pm: 'di tardi',
  midnight: 'meia noti',
  noon: 'meiu dia',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night',
};

const abbreviatedDayPeriodValues = {
  ...defaultDayPeriodValues,
  am: 'SEDU',
  pm: 'TARDI',
};

const dayPeriodValues = {
  narrow: abbreviatedDayPeriodValues,
  abbreviated: abbreviatedDayPeriodValues,
  wide: defaultDayPeriodValues,
};

const defaultFormattingDayPeriodValues = {
  am: 'di sedu',
  pm: 'di tardi',
  midnight: 'meia noti',
  noon: 'meiu dia',
  morning: 'in the morning',
  afternoon: 'in the afternoon',
  evening: 'in the evening',
  night: 'at night',
};

const abbreviatedFormattingDayPeriodValues = {
  ...defaultFormattingDayPeriodValues,
  am: 'SEDU',
  pm: 'TARDI',
};

const formattingDayPeriodValues = {
  narrow: abbreviatedFormattingDayPeriodValues,
  abbreviated: abbreviatedFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues,
};

export const localize: Locale['localize'] = {
  ordinalNumber: enUsLocale.localize!.ordinalNumber,
  era: enUsLocale.localize!.era,
  quarter: enUsLocale.localize!.quarter,
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
